export const authHeaders = () => {
  const strapiJwt = localStorage.getItem('bjwt')
  return {
    headers: {
      Authorization: `Bearer ${strapiJwt}`,
    },
  }
}
